import React, { useState, useCallback, useRef } from 'react'
import debounce from 'lodash/debounce'
import { Icon, Input } from 'semantic-ui-react'
import { convertDateToUTCInSec, convertDateToUTCEpochInSec, convertEpochToUTC, } from './utils'
import InputField from '@commonComponents/formComponents/inputField'

function filterBodyInputTemplate(props) {
    const { callback, name } = props
    const [input, setInput] = useState('')

    const debouncedCallback = useRef(
        debounce((params) => callback(params), 400)
    ).current

    const onChange = useCallback((e) => {
        let value = e.target.value
        setInput(value)
        debouncedCallback({ name, value })
    }, [name, debouncedCallback])

    const handleClear = useCallback(() => {
        setInput('')
        debouncedCallback({ name, value: '' })
    }, [name, debouncedCallback])

    return (
        <div className='table-filters'>
            <Input type='text' name={name} value={input} onChange={onChange} />
            {input && <Icon name='filter' onClick={handleClear} />}
        </div>
    )
}

const filterBodyDateTemplate = (props) => {

    const { name, callback } = props
    const [input, setInput] = useState('')

    const debouncedCallback = useRef(
        debounce((params) => callback(params), 400)
    ).current

    const onChange = useCallback((e) => {
        let value = e?.value
        setInput(value)
        debouncedCallback({ name, value })
    }, [name, debouncedCallback])

    return (
        <InputField
            isLabel={false}
            id='name'
            type='date'
            className='field-bg'
            value={input ? convertDateToUTCInSec(Number(input)) : ''}
            clearInput={true}
            onChange={(value) => {
                value = value ? convertDateToUTCEpochInSec(value) : ''
                onChange({ value })
            }}
            isDisabled={false}
            popupPosition="right"
        />
    )
}

const bodyDateTemplate = ({ value }) => {
    return (
        <div>
            {value ? convertEpochToUTC(Number(value)) : ''}
        </div>
    )
}

const sortTemplate = (props) => {
    const { name, sort = {}, callback } = props

    const [key = '', value = ''] = Object.entries(sort)?.[0] || [];

    return (
        <>
            {key !== name && (<Icon name="sort cursor-pointer" onClick={() => callback({ name, value: 'asc' })} />)}
            {key === name && value === 'asc' && (<Icon name="sort content ascending icon-header-sort cursor-pointer" onClick={() => callback({ name, value:'desc' })} />)}
            {key === name && value === 'desc' && (<Icon name="sort content descending icon-header-sort cursor-pointer" onClick={() => callback({})} />)}
        </>
    )
}

const filterMap = { input: filterBodyInputTemplate, date: filterBodyDateTemplate }

const bodyMap = { date: bodyDateTemplate }

const sortMap = { sortTemplate }

export { filterMap, bodyMap, sortMap }